import { Link } from "react-router-dom";
import type { Dashboard } from "../../api/dashboard";
import { Card } from "../../components/ui";

/** Every site in one bar, split by status, with a legend that doubles as the
 * way into the site list at that status. One bar rather than eight tiles,
 * because the question is the proportion, and a row of equal tiles hides it. */
export function StatusCard({ data, colours }: { data: Dashboard; colours: Record<string, string> }) {
  const total = data.total_sites;
  const tiles = data.status_tiles;
  return (
    <Card
      className="dash-card"
      title="Sites by status"
      sub={`${total} site${total === 1 ? "" : "s"} in all`}
      actions={
        <Link className="go-link" to="/sites">
          Open Sites →
        </Link>
      }
    >
      {total === 0 ? (
        <p className="empty-state">No sites yet. They arrive with the first QCP upload.</p>
      ) : (
        <>
          <div
            className="status-bar"
            role="img"
            aria-label={tiles.map((t) => `${t.label}: ${t.value}`).join(", ")}
          >
            {tiles
              .filter((t) => t.value > 0)
              .map((t) => (
                <span
                  key={t.status}
                  title={`${t.label}: ${t.value}`}
                  style={{ width: `${(t.value / total) * 100}%`, background: colours[t.status] }}
                />
              ))}
          </div>
          <ul className="status-legend" aria-label="Sites by status">
            {tiles.map((t) => (
              <li key={t.status}>
                <Link to={t.href}>
                  <span className="legend-swatch" style={{ background: colours[t.status] }} />
                  <span className="legend-label">{t.label}</span>
                  <strong>{t.value}</strong>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </Card>
  );
}
